"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripFolder = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const expense_model_1 = require("./expense.model");
const expenseKind_enum_1 = require("./expenseKind.enum");
class TripFolder extends expense_model_1.Expense {
    constructor(input) {
        super(input);
        /**
         * * Can be usefull to generate the initial folder name
         */
        this.getInitialFolderName = () => `#${this.expenseNumber} - ${this.formatDateForFolderName(this.tripDate)} - ${this.formatDateForFolderName(this.returnDate)} - ${this.destination}`;
        this.formatDateForFolderName = (dateObject) => (0, moment_timezone_1.default)(dateObject).format("DD-MM-YYYY");
        this.kind = (input === null || input === void 0 ? void 0 : input.kind) || expenseKind_enum_1.ExpenseKindEnum.TRIP_FOLDER;
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input.id || input._id;
        return this;
    }
}
exports.TripFolder = TripFolder;
